<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img src="../../../public/static/no_user.jpg" block class="c-avatar-img"/>
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Cuenta</strong>
    </CDropdownHeader>
    <CDropdownItem class="d-flex flex-column">
      <div class="text-muted font-weight-bold col-sm-12">Usuario:</div>
      <div class="col-sm-12">{{$store.state.user.data.nombre_Usuario}}</div>
    </CDropdownItem>
    <CDropdownItem class="d-flex flex-column">
      <div class="text-muted font-weight-bold col-sm-12">Último ingreso:</div>
      <div class="col-sm-12">{{moment($store.state.user.data.ultimo_Ingreso).format('DD/MM/YYYY HH:mm')}}</div>
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem @click="changePassword()">
      <CIcon name="cil-lock-locked" class="mr-2" />Cambio Contraseña
    </CDropdownItem>
    <CDropdownItem @click="logOut()">
      <CIcon name="cil-exit-to-app" class="mr-2" />Cerrar Sesión
    </CDropdownItem>
  </CDropdown>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'HeaderDrop',
    data() {
      return {
        moment
      }
    },
    props: {
      changePassword: Function,
      logOut: Function
    }
  }
</script>
<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
